import { GetProductUrl } from '@app/logic/products';
import { Product } from '@typings';
import { useTranslation } from 'react-i18next';

import { NativeVariants, RelatedVariants } from './components';
import { useProductVariants } from './useProductVariants';

interface Props {
  activeVariant: Product.Standard;
  productDetails: Product.Standard;
  variants: Product.Standard[];
  getProductUrl: GetProductUrl;
}

export const VariantsThumbnailsNavigation = ({ activeVariant, productDetails, variants, getProductUrl }: Props) => {
  const { t } = useTranslation(['products']);

  const { nativeVariants, showNativeVariants, relatedVariants, isSingleProduct, showDistinctVariantRelation } = useProductVariants({
    productDetails,
    variants,
  });

  if (!showNativeVariants && relatedVariants.length <= 1) {
    return null;
  }

  return (
    <div className="flex flex-col gap-5">
      <h3 className="heading-3">{t('products:available_variants')}</h3>
      <ul className="flex flex-wrap gap-2">
        {showNativeVariants && <NativeVariants variants={nativeVariants} activeVariant={activeVariant} getProductUrl={getProductUrl} />}
        {(!isSingleProduct || showDistinctVariantRelation) && (
          <RelatedVariants productDetails={productDetails} variants={relatedVariants} getProductUrl={getProductUrl} />
        )}
      </ul>
    </div>
  );
};
